export const wizardOnboardingContainerQueryStyles = `
.wizard-onboarding-root-scroll {
  container: wizardOnboardingRootScroll / inline-size;
}

.wizard-onboarding-root {
  padding: 60px 20vh 80px 20vh;

  container: wizardOnboardingRoot / inline-size;

  h3 {
    white-space: nowrap;
  }
}

.wizard-onboarding-small-panel-container {
  display: flex;
  flex: 1;
  min-height: 50%;
}

.wizard-onboarding-small-panel {
  container: wizardOnboardingSmallPanel / inline-size;
}

.wizard-onboarding-small-panel-content {
}

.wizard-instruction {
  max-width: 200px;
}

.wizard-onboarding-large-panel {
  container: wizardOnboardingLargePanel / inline-size;
}

@container wizardOnboardingLargePanel (inline-size < 660px) and (inline-size > 540px) {
  * h3 {
    font-size: 18px !important;
  }
}

@container wizardOnboardingRootScroll (inline-size < 960px) {
  .wizard-onboarding-root {
    padding: 60px 30px 80px 30px;
  }
}

@container wizardOnboardingRootScroll (inline-size < 624px) {
  .wizard-onboarding-root {
    overflow-y: scroll;
  }
}

@container wizardOnboardingRoot (inline-size < 560px) {
  .wizard-onboarding-small-panel-container {
    flex-direction: column;
  }
}

@container wizardOnboardingSmallPanel (inline-size < 320px) {
  h3 {
    font-size: 18px !important;
  }
}

.wizard-onboarding-small-panel-content {
}

.wizard-onboarding-small-panel {
}

`;
